<template>
  <div class="d-flex table-container">
    <table class="mark-table">
      <thead>
        <tr>
          <th>STT</th>
          <th>Mã định danh</th>
          <th class="text-left">Họ tên</th>
          <th class="text-left">Ngày sinh</th>
          <th class="text-left" v-if="isClassExtraCurriculum">Lớp</th>
          <th class="factor-header" v-for="factor in excelFactors" :key="factor.id" :colspan="factor.maxCol">
            {{ factor.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in excelData" :key="item.index">
          <td style="width: 10px">{{ item.index }}</td>
          <td style="width: 130px">{{ item.code }}</td>
          <td class="text-left" style="width:300px;">{{ item.name }}</td>
          <td class="text-left" style="width:100px;">{{ item.dob }}</td>
          <td class="text-left" style="width:100px;" v-if="isClassExtraCurriculum">{{ item.classTitle }}</td>

          <td v-for="(mark, mIdx) in item.marks_1" :key="`1_${mIdx}`">
            <span>{{ mark }}</span>
          </td>
          <td v-for="(mark, mIdx) in item.marks_2" :key="`2_${mIdx}`">
            <span>{{ mark }}</span>
          </td>
          <td v-for="(mark, mIdx) in item.marks_3" :key="`3_${mIdx}`">
            <span>{{ mark }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('ClassMarkInput', ['excelFactors', 'excelData', 'isClassExtraCurriculum'])
  }
}
</script>

<style lang="scss" scoped>
.mark-table {
  td,
  tr,
  th {
    border: 1px solid #e0e0e0;
  }
  td,
  th {
    padding: 12px 16px;
    text-align: center;
  }
  .factor-header {
    font-size: 18px;
    text-transform: uppercase;
  }
  color: #212121;
  border-collapse: collapse;
  width: 100%;
}
.table-container {
  overflow: auto;
  max-width: 100%;
}
</style>
